export default "__VITE_ASSET__Ct83aNY___"